module.exports = __webpack_public_path__ + "static/media/idli.92eae66d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/idli.jpg
// module id = 202
// module chunks = 0